import * as React from 'react';
import {Mutation} from 'react-apollo';

import {IntegrationWidget} from 'shells/integration-widget/integration-widget';
import ExchangeIcon from 'shells/logos/exchange.svg';

import type {
    setExchangeUsername as setExchangeUsernameMutation,
    setExchangeUsernameVariables as setExchangeUsernameMutationVariables,
} from 'nutshell-graphql-types';

import SET_EXCHANGE_USERNAME from './graphql/mutations/set-exchange-username.graphql';

const exchangeLogo = <ExchangeIcon width={24} />;

class SetExchangeUsernameMutation extends Mutation<
    setExchangeUsernameMutation,
    setExchangeUsernameMutationVariables
> {}

type Props = {
    username: string;
    isEnabled: boolean;
    onAuthStart: () => void;
    onAuthSuccess: () => Promise<any>;
    onAuthError: (arg1: string) => void;
};

export function WidgetExchange(props: Props) {
    const [isAuthenticating, setIsAuthenticating] = React.useState<boolean>(false);

    return (
        <SetExchangeUsernameMutation mutation={SET_EXCHANGE_USERNAME}>
            {(setExchangeUsername, {loading: isMutationInFlight}) => {
                let status = props.isEnabled ? 'enabled' : 'disabled';
                if (isMutationInFlight || isAuthenticating) {
                    status = props.isEnabled ? 'disabling' : 'enabling';
                }

                return (
                    <IntegrationWidget
                        // @ts-expect-error
                        status={status}
                        account={props.username}
                        logo={exchangeLogo}
                        onConnectClick={() => {
                            // We don't allow reconnecting here
                        }}
                        onDisconnectClick={() => {
                            setIsAuthenticating(true);
                            props.onAuthStart();
                            setExchangeUsername({variables: {username: null}})
                                .then(() => {
                                    props.onAuthSuccess();
                                })
                                .catch((errMsg) => {
                                    props.onAuthError(errMsg);
                                });
                        }}
                    />
                );
            }}
        </SetExchangeUsernameMutation>
    );
}
